/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose } from 'redux';
import { loadOfferAssets, deleteOfferAsset } from './asset/actionCreators';
import { checkAssetHierarchyTriggers, loadAssetTypes } from 'features/asset/hierarchy/actionCreators';
import OfferAssetListComponent from './OfferAssetListComponent';
import OfferAssetClientContainer from './client/components/OfferAssetClientContainer';
import OfferAssetGeneralDetailsContainer from './generalDetails/components/OfferAssetGeneralDetailsContainer';
import { withRouter } from 'react-router-dom';
import { Button } from '@totalsoft/rocket-ui';
import { withTranslation } from 'react-i18next';
import { RightsContext } from 'providers/RightsContext';
import { ApplicationFeaturesContext } from 'providers/ApplicationFeaturesContext';
import { Grid } from '@mui/material';

export const OfferAssetListContainer = ({
  assets,
  history,
  actions,
  documentId,
  siteId,
  assetImages,
  assetTypes,
  t,
  deleting,
  isLoaded,
  documentTypeId,
  isFacilityFrame,
  isContractModification,
  processing
}) => {
  const { financedAssetWrite, financedAssetClientRead, isReadOnly, isImage } = useContext(RightsContext);
  const { offerWithMultipleAssets } = useContext(ApplicationFeaturesContext);

  useEffect(() => {
    if (Number.isInteger(documentId)) {
      if (!isLoaded) {
        actions.loadOfferAssets(documentId, siteId);
      }
    }
  }, [documentId, siteId, isLoaded]);

  useEffect(() => {
    assets.filter(z => z.hierarchy).map(z => actions.checkAssetHierarchyTriggers(z.hierarchy));
  }, [assets]);

  useEffect(() => {
    actions.loadAssetTypes();
  }, [actions]);

  const onEdit = (documentDetailId, siteId) => () => {
    isFacilityFrame
      ? history.push(`/offers/${documentId}/${siteId}/generalInfo/${documentDetailId}`)
      : history.push(`/offers/${documentId}/${siteId}/assets/${documentDetailId}`);
  };

  const onAddAsset = () => {
    isFacilityFrame
      ? history.push(`/offers/${documentId}/${siteId}/generalInfo/new`)
      : history.push(`/offers/${documentId}/${siteId}/assets/new`);
  };

  const onDeleteAsset = asset => () => {
    actions.deleteOfferAsset(asset);
  };

  return (
    <>
      <OfferAssetGeneralDetailsContainer
        documentId={documentId}
        siteId={siteId}
        isFacilityFrame={isFacilityFrame}
        isContractModification={isContractModification}
      />

      <OfferAssetListComponent
        assets={assets}
        onEdit={onEdit}
        onDeleteAsset={onDeleteAsset}
        assetImages={assetImages}
        assetTypes={assetTypes}
        deleting={deleting}
      />

      {!isImage && offerWithMultipleAssets && financedAssetWrite && !isReadOnly && (
        <Grid container justifyContent='end'>
          <Button id={'offerAsset_addAssetBtn'} disabled={processing} onClick={onAddAsset}>
            {t('AddAsset')}
          </Button>
        </Grid>
      )}

      {financedAssetClientRead && (
        <OfferAssetClientContainer
          contactData={{}}
          documentId={documentId}
          siteId={siteId}
          documentTypeId={documentTypeId}
          isFacilityFrame={isFacilityFrame}
        />
      )}
    </>
  );
};

OfferAssetListContainer.propTypes = {
  assets: PropTypes.array.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  actions: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  assetImages: PropTypes.object.isRequired,
  assetTypes: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  deleting: PropTypes.bool.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  documentTypeId: PropTypes.number.isRequired,
  isFacilityFrame: PropTypes.bool,
  isContractModification: PropTypes.bool,
  processing: PropTypes.bool
};

function mapStateToProps(state) {
  const assetImages = state.assetData.images;
  const isLoaded = state.currentOffer.assetData.assets.isLoaded;
  const assetTypes = state.assetData.assetTypes;
  return {
    isLoaded: isLoaded,
    assets: state.currentOffer.assetData.assets,
    assetImages: assetImages,
    assetTypes: assetTypes,
    deleting: state.currentOffer.assetData.deleting
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadOfferAssets, loadAssetTypes, checkAssetHierarchyTriggers, deleteOfferAsset }, dispatch),
    dispatch
  };
}

export default withRouter(compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(OfferAssetListContainer));
